import { render, staticRenderFns } from "./IntegrationHealthBanner.vue?vue&type=template&id=10007932&scoped=true"
import script from "./IntegrationHealthBanner.vue?vue&type=script&lang=js"
export * from "./IntegrationHealthBanner.vue?vue&type=script&lang=js"
import style0 from "./IntegrationHealthBanner.vue?vue&type=style&index=0&id=10007932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10007932",
  null
  
)

export default component.exports